import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { SuperButton } from "@swiggy-private/dls-web-core/dist/components/SuperButton";
import { getCornerRadius } from "@swiggy-private/dls-web-common/dist/components/themes/CornerRadiusMapping/mapping";

export const Container = styled.div(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    margin: `${theme.spacing.xLarge} ${theme.spacing.medium} ${theme.spacing.xxSmall}`,
}));

export const SubTitleText = styled(Text)<{ isQuickCheckout?: boolean }>`
    margin-top: ${({ isQuickCheckout }) => (isQuickCheckout ? "2px" : "6px")};
    overflow: hidden;
    padding-right: 28px;
`;

export const ActionsSection = styled.div(({ theme }) => ({
    width: "100%",
    margin: `${theme.spacing.xLarge} ${theme.spacing.empty} ${theme.spacing.empty}`,
    display: "flex",
    gap: theme.spacing.small,
    "& > div": {
        flex: 1,
    },
}));

export const ActionButton = styled(SuperButton)(({ theme }) => ({
    borderRadius: getCornerRadius(theme, "small"),
}));

export const ContainerMeta = styled.div({
    display: "flex",
});

export const MetaTextWrapper = styled.div(({ theme }) => ({
    paddingLeft: theme.spacing.xSmall,
}));
